import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import useFlightDeal from 'hooks/Flights/useFlightDeal'
import { useParams } from 'react-router'
import FlightDealContent from './FlightDealContent'
import { FlightDealHeadData } from './FlightDealHeadData'

function FlightDealLandingPage() {
  const params = useParams<{ id: string }>()

  const [flightDeal, fetching, error] = useFlightDeal(params.id)

  if (error) {
    return <Error404PageWithOffers />
  }

  if (fetching || !flightDeal) {
    return <LoadingIndicator />
  }

  return <>
    <FlightDealHeadData deal={flightDeal} />
    <FlightDealContent flightDeal={flightDeal} />
  </>
}

export default FlightDealLandingPage
